import React, { useState } from 'react';

import { CreateBadgeRequest, UpdateBadgeRequest } from '../../../../api/badge/badge.types';
import { Badge } from '../../../../types/entity.types';

import Button from '../../../common/button/Button';
import Image from '../../../common/image/Image';
import ManageBadgeModal from './modal/ManageBadgeModal';

import { ReactComponent as EditIcon } from '../../../../resources/icons/edit.svg';

import './badge-settings.scss';

type Props = {
  badges: Badge[];
  createBadge: (badge: CreateBadgeRequest, onSuccess: () => void) => void;
  updateBadge: (badge: UpdateBadgeRequest, onSuccess: () => void) => void;
  deleteBadge: (externalReference: string, onSuccess: () => void) => void;
};

const BadgeSettings = ({ badges, createBadge, updateBadge, deleteBadge }: Props) => {
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [badge, setBadge] = useState<Badge>();

  const showModal = () => setIsModalVisible(true);

  const handleEditClick = (badge: Badge) => {
    setBadge(badge);
    showModal();
  };

  const closeModal = () => {
    setIsModalVisible(false);
    setBadge(undefined);
  };

  return (
    <section className="badge-settings">
      <h2>Member Badge Settings</h2>
      <section className="badge-settings__badge-container">
        <p>Badges:</p>

        {badges.length === 0 ? (
          <Button className="badge-settings__inline-add-button" text="Add" onClick={showModal} />
        ) : (
          <div className="badge-settings__badges">
            {badges.map((badge) => (
              <div className="badge-settings__badge" key={badge.externalReference}>
                <div className="badge-settings__badge__icon-container">
                  <Image className="badge-settings__badge__icon" src={badge.iconExternalReference} />
                </div>
                <p className="badge-settings__badge__name">{badge.badgeName}</p>
                <EditIcon
                  className="badge-settings__badge__edit-icon"
                  onClick={() => handleEditClick(badge)}
                  data-testid="badge-edit-icon"
                />
              </div>
            ))}
          </div>
        )}
      </section>
      {badges.length > 0 && <Button className="badge-settings__add-button" text="Add" onClick={showModal} />}

      {isModalVisible && (
        <ManageBadgeModal
          badge={badge}
          createBadge={createBadge}
          updateBadge={updateBadge}
          deleteBadge={deleteBadge}
          close={closeModal}
        />
      )}
    </section>
  );
};

export default BadgeSettings;
